export class HideSpinner {
  static readonly type = '[UI] Hide Spinner';
}​
